var _rect, _rect2, _line, _line2, _line3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.70581,
    y: 4.85828,
    width: 18.0273,
    height: 14.2833,
    rx: 3,
    stroke: "#444242",
    strokeWidth: 1.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.87329,
    y: 7.84473,
    width: 5.53711,
    height: 4.85608,
    rx: 1,
    stroke: "#444242",
    strokeWidth: 1.3
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 15.0648,
    y1: 9.01516,
    x2: 18.4152,
    y2: 9.01516,
    stroke: "#444242",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 7.02354,
    y1: 15.505,
    x2: 18.4152,
    y2: 15.505,
    stroke: "#444242",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 15.0648,
    y1: 12.0508,
    x2: 18.4152,
    y2: 12.0508,
    stroke: "#444242",
    strokeWidth: 1.3,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog);
export default __webpack_public_path__ + "static/media/Blog.30d6b08a7fe492915f8889935b1c0811.svg";
export { ForwardRef as ReactComponent };